/**
 * ArrowUpIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ArrowUpIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m19.714 11.296-7-7a1 1 0 0 0-1.42 0l-7 7a1.004 1.004 0 0 0 1.42 1.42l5.29-5.3v11.59a1 1 0 1 0 2 0V7.416l5.29 5.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ArrowUpIcon = makeIcon('ArrowUpIcon', ArrowUpIconSvg)
